import { useQuery } from "@tanstack/react-query";

import { getProduct } from "../core/product.core";

export default function useSingleProductQuery(productId?: string) {
  return useQuery({
    queryKey: ["product", productId],
    queryFn: (context) => getProduct(context.queryKey[1] as string),
    enabled: !!productId,
  });
}
